import { useState } from "react";
import { Navigate } from "react-router-dom";
import PwResetUser from "../../Components/PwResetUser";
import StandortModal from "../../Components/StandortModal/StandortModal";
import TextBauSteine from "../../Components/TextbauSteine";
import CustomButton from "../../Components/Ui/CustomButton";
import { useAuth } from "../../Store/auth-context";
import { useUIContext } from "../../Store/ui-context";

const HomePage: React.FC<{}> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { token, login, logout } = useAuth();

  const [showStartOrt, setShowStartOrt] = useState(false);
  const [showPwReset, setShowPwReset] = useState(false);

  const {
    setShowTextbauSteine,
    showTextbauSteine,
    // showDialog,
    // openErrorModal,
  } = useUIContext();

  const closePwReset = () => {
    setShowPwReset(false);
  };

  if (showStartOrt) {
  }

  function textSelectedDummy(text: string) {}

  let content = (
    <div className="flex justify-around mt-10">
      {!showPwReset ? (
        <>
          <CustomButton
            className="mb-4 w-[200px]"
            theme="navy"
            onClick={() => {
              setShowTextbauSteine(true);
            }}
          >
            Textbausteine pflegen
          </CustomButton>
          <CustomButton
            className="mb-4 w-[200px]"
            theme="navy"
            onClick={() => {
              setShowPwReset(true);
            }}
          >
            Passwort ändern
          </CustomButton>
          <CustomButton
            className="mb-4 w-[200px]"
            theme="navy"
            onClick={() => {
              setShowStartOrt(true);
            }}
          >
            Startort festlegen
          </CustomButton>
          {showStartOrt && (
            <StandortModal
              isVisible={true}
              onClose={() => {
                setShowStartOrt(false);
              }}
            />
          )}
        </>
      ) : (
        <>
          <PwResetUser closeModal={() => closePwReset()} />
        </>
      )}
    </div>
    // </div>
  );

  if (showTextbauSteine) {
    content = <TextBauSteine textSelected={textSelectedDummy} />;
  }

  return <div>{token ? content : <Navigate to={"/login"} />}</div>;
};

export default HomePage;
